<template>
  <div
    class="wrap-icon-open-id-and-connect-btn"
    :class="{ connected: isGoogleEnabled() }"
  >
    <a
      class="social-link"
      :href="getGoogleLink()"
    >
      <RoundGoogleIcon />
      <span class="connect-btn">
        {{ 
          isGoogleEnabled()
            ? $t('profile.open_id.btn.cancel') 
            : $t('profile.open_id.btn.assign')  
        }}
      </span>
    </a>
  </div>
</template>

<script>
  import Store from '@/store'

  export default {
    name: 'GoogleIconText',
    components: {

    },
    methods: {
      isGoogleEnabled: function () {
        return Store.state.user.signin.google_enabled
      },
      getGoogleLink: function () {
        return this.isGoogleEnabled()
          ? 'https://auth2.multiplex.ua/gadisconnect'
          : 'https://auth2.multiplex.ua/gaconnect'
      }
    }
  }
</script>


// WEBPACK FOOTER //
// GoogleIconText.vue?d59f5024